import { TRIGGER } from "../actionTypes";

const triggerAction = (value) => {
    return {
        type: TRIGGER,
    };
}

export { triggerAction };